<div class="layout-dashboard">
	<div class="grid">
		<ng-container *ngIf="productsStatistics">
			<div class="col-12 md:col-6 xl:col-3">
				<div class="card flex flex-column w-full relative h-10rem overflow-hidden" [style.borderColor]="'#64B5F6'" [style]="{'border-color': '#64B5F6', 'border-left': '4px solid'}">
					<div class="flex align-items-center">
						<div class="flex justify-content-center align-items-center p-2 border-round" [style.backgroundColor]="'#64B5F6'">
							<i class="fas fa-tags" [style.color]="'#1976D2'"></i>
						</div>
						<span class="text-xl ml-2 font-semibold" [style.color]="'#64B5F6'">Produkter</span>
					</div>
	
					<div class="grid mt-3 overview-detail">
						<div class="col-6 flex flex-column p-2 text-center">
							<span class="text-color text-2xl font-semibold">{{productsStatistics.productsCount | number: '1.0-0'}}st</span>
							<span class="overview-subtext mt-1">Produkter</span>
						</div>
						<div class="col-6 flex flex-column p-2 text-center">
							<span class="text-color text-2xl font-semibold">{{productsStatistics.competitorUrlsCount | number: '1.0-0'}}st</span>
							<span class="overview-subtext mt-1">Konkurrenter</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 md:col-6 xl:col-3">
				<div class="card flex flex-column w-full relative h-10rem overflow-hidden" [style.borderColor]="'#7986CB'" [style]="{'border-color': '#7986CB', 'border-left': '4px solid'}">
					<div class="flex align-items-center">
						<div class="flex justify-content-center align-items-center p-2 border-round" [style.backgroundColor]="'#7986CB'">
							<i class="fas fa-tags" [style.color]="'#303F9F'"></i>
						</div>
						<span class="text-xl ml-2 font-semibold" [style.color]="'#7986CB'">Bevakade produkter</span>
					</div>
	
					<div class="grid mt-3 overview-detail">
						<div class="col-6 flex flex-column p-2 text-center">
							<span class="text-color text-2xl font-semibold">{{productsStatistics.productsCompetitorCount | number: '1.0-0'}}st</span>
							<span class="overview-subtext mt-1">Antal</span>
						</div>
						<div class="col-6 flex flex-column p-2 text-center">
							<span class="text-color text-2xl font-semibold">{{productsStatistics.productsCompetitorPercentage}}%</span>
							<span class="overview-subtext mt-1">Procent</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 md:col-6 xl:col-3">
				<div class="card flex flex-column w-full relative h-10rem overflow-hidden" [style.borderColor]="'#4DB6AC'" [style]="{'border-color': '#4DB6AC', 'border-left': '4px solid'}">
					<div class="flex align-items-center">
						<div class="flex justify-content-center align-items-center p-2 border-round" [style.backgroundColor]="'#4DB6AC'">
							<i class="fas fa-tags" [style.color]="'#00796B'"></i>
						</div>
						<span class="text-xl ml-2 font-semibold" [style.color]="'#4DB6AC'">Match eller billigast</span>
					</div>
	
					<div class="grid mt-3 overview-detail">
						<div class="col-6 flex flex-column p-2 text-center">
							<span class="text-color text-2xl font-semibold">{{productsStatistics.productsLowerOrSamePriceCount | number: '1.0-0'}}st</span>
							<span class="overview-subtext mt-1">Antal</span>
						</div>
						<div class="col-6 flex flex-column p-2 text-center">
							<span class="text-color text-2xl font-semibold">{{productsStatistics.productsLowerOrSamePricePercentage}}%</span>
							<span class="overview-subtext mt-1">Procent</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 md:col-6 xl:col-3">
				<div class="card flex flex-column w-full relative h-10rem overflow-hidden" [style.borderColor]="'#4DD0E1'" [style]="{'border-color': '#4DD0E1', 'border-left': '4px solid'}">
					<div class="flex align-items-center">
						<div class="flex justify-content-center align-items-center p-2 border-round" [style.backgroundColor]="'#4DD0E1'">
							<i class="fas fa-tags" [style.color]="'#0097A7'"></i>
						</div>
						<span class="text-xl ml-2 font-semibold" [style.color]="'#4DD0E1'">Billigast</span>
					</div>
	
					<div class="grid mt-3 overview-detail">
						<div class="col-6 flex flex-column p-2 text-center">
							<span class="text-color text-2xl font-semibold">{{productsStatistics.productsLowerPriceCount | number: '1.0-0'}}st</span>
							<span class="overview-subtext mt-1">Antal</span>
						</div>
						<div class="col-6 flex flex-column p-2 text-center">
							<span class="text-color text-2xl font-semibold">{{productsStatistics.productsLowerPricePercentage}}%</span>
							<span class="overview-subtext mt-1">Procent</span>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
